import Preloader from "./comps/pre-loader/pre-loader.vue";
import ThemifyIcon from "vue-themify-icons";
import CookieLaw from "vue-cookie-law";
import { ApiService, TermsService } from "@/services";

export default {
  name: "app",
  components: {
    Preloader,
    ThemifyIcon,
    CookieLaw,
  },
  data() {
    return {
      cookie: "",
      locales: [
        "af",
        "ar",
        "bn",
        "zh",
        "cs",
        "da",
        "nl",
        "en",
        "fr",
        "de",
        "el",
        "he",
        "hi",
        "hu",
        "it",
        "ja",
        "jv",
        "lt",
        "fa",
        "pl",
        "pt-br",
        "pt",
        "ro",
        "ru",
        "sk",
        "es",
        "sv",
        "th",
        "tr",
        "uk",
      ],
    };
  },
  async mounted() {
    await this.$store.dispatch("refreshSiteSettings");

    if (!localStorage.getItem("theme") && this.settings.default_theme) {
      localStorage.setItem("theme", this.settings.default_theme);
    }

    // checking if the user is customer and not admin
    if (this.user && this.user.role_id && this.user.role_id === 2) {
      await this.$store.dispatch("refreshShoppingCart");
    }

    this.$store.dispatch("refreshThemeSettings").then((data) => {
      let htmlElement = document.documentElement;
      let theme = localStorage.getItem("theme");

      if (!theme) {
        theme = this.settings.default_theme;
      }

      if (theme && theme === "custom") {
        const root = document.querySelector(":root");
        root.style.setProperty("--bg-color-9", data.card_bg_color);
        root.style.setProperty("--text-color-7", data.card_text_color);
        root.style.setProperty("--bg-color-2", data.header_bar_color);
        root.style.setProperty("--text-color-3", data.header_bar_text_color);
        root.style.setProperty("--vehicle_bg_color", data.vehicle_bg_color);
        root.style.setProperty("--vehicle_text_color", data.vehicle_text_color);
        root.style.setProperty(
          "--price_options_bg_color",
          data.price_options_bg_color || "#fcb040"
        );
        root.style.setProperty(
          "--price_options_text_color",
          data.price_options_text_color || "#ffffff"
        );
        root.style.setProperty(
          "--order_upload_btn_bg_color",
          data.order_upload_btn_bg_color
        );
      } else {
        let theme_data = {
          ...data,
          header_top_color: "",
          header_bar_color: "",
          header_top_text_color: "",
          header_bar_text_color: "",
          left_bar_color: "",
          left_bar_text_color: "",
          card_bg_color: "",
          card_text_color: "",
          body_bg_color: "",
        };
        this.$store.commit("update_theme_settings", theme_data);
      }

      if (theme === "light" || theme === "default") {
        htmlElement.setAttribute("theme", "light");
      } else if (theme === "red") {
        htmlElement.setAttribute("theme", "red");
      } else {
        htmlElement.setAttribute("theme", "dark");
      }
    });

    let locale = localStorage.getItem("locale");
    if (locale && this.locales.includes(locale)) {
      this.$i18n.locale = locale;
      document.documentElement.lang = locale;
    } else {
      this.$i18n.locale = "en";
      document.documentElement.lang = "en";
    }

    if (this.user?.role_id === 2) {
      ApiService.hasAccessToVehicleStatisticsApi()
        .then((data) => {
          this.$store.commit(
            "setHasAccessToVehicleStatisticsApi",
            data?.status === "success"
          );
        })
        .catch(() => {
          this.$store.commit("setHasAccessToVehicleStatisticsApi", false);
        });
    }

    TermsService.getTermsAndPolicy().then((data) => {
      this.cookie = data.cookie;
    });
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
    user() {
      return this.$store.state.user;
    },
    body_bg_color() {
      return "background-color:" + this.theme.body_bg_color;
    },
    settings() {
      return this.$store.state.settings;
    },
  },
  watch: {
    "settings.default_theme": {
      handler(newTheme, oldTheme) {
        if (newTheme && newTheme !== oldTheme) {
          localStorage.setItem("theme", newTheme);

          this.applyTheme(newTheme);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    applyTheme(theme) {
      let htmlElement = document.documentElement;
      const root = document.querySelector(":root");

      if (theme === "custom") {
        this.$store.dispatch("refreshThemeSettings").then((data) => {
          root.style.setProperty("--bg-color-9", data.card_bg_color);
          root.style.setProperty("--text-color-7", data.card_text_color);
          root.style.setProperty("--bg-color-2", data.header_bar_color);
          root.style.setProperty("--text-color-3", data.header_bar_text_color);
          root.style.setProperty("--vehicle_bg_color", data.vehicle_bg_color);
          root.style.setProperty(
            "--vehicle_text_color",
            data.vehicle_text_color
          );
          root.style.setProperty(
            "--price_options_bg_color",
            data.price_options_bg_color || "#fcb040"
          );
          root.style.setProperty(
            "--price_options_text_color",
            data.price_options_text_color || "#ffffff"
          );
          root.style.setProperty(
            "--order_upload_btn_bg_color",
            data.order_upload_btn_bg_color
          );
          htmlElement.setAttribute("theme", "dark");
        });
      } else {
        let theme_data = {
          ...this.theme,
          header_top_color: "",
          header_bar_color: "",
          header_top_text_color: "",
          header_bar_text_color: "",
          left_bar_color: "",
          left_bar_text_color: "",
          card_bg_color: "",
          card_text_color: "",
          body_bg_color: "",
        };
        this.$store.commit("update_theme_settings", theme_data);

        if (theme === "light" || theme === "default") {
          htmlElement.setAttribute("theme", "light");
        } else if (theme === "red") {
          htmlElement.setAttribute("theme", "red");
        } else {
          htmlElement.setAttribute("theme", "dark");
        }
      }
    },
  },
};
